import type { BoundingBox, Point } from "../types";
import { ConversionProvider } from "./ConversionProvider";
import { DimensionsProvider } from "./DimensionsProvider";
import { GestureHandler } from "./GestureHandler";
import { PanProvider } from "./PanProvider";
import { PerspectiveListener } from "./PerspectiveListener";
import { ZoomProvider } from "./ZoomProvider";

export const Perspective = ({
  initialValue,
  width,
  height,
  padding,
  onChange,
  onMapBoundsChange,
  children,
}: {
  initialValue: { zoom: number; pan: Point };
  width: number;
  height: number;
  padding: number;
  onChange: (perspective: { zoom: number; pan: Point }) => void;
  onMapBoundsChange: (mapBounds: BoundingBox) => void;
  children: React.ReactNode;
}) => (
  <DimensionsProvider width={width} height={height} padding={padding}>
    <ZoomProvider initialValue={initialValue.zoom}>
      <PanProvider initialValue={initialValue.pan}>
        <PerspectiveListener onChange={onChange}>
          <ConversionProvider>
            <GestureHandler onMapBoundsChange={onMapBoundsChange}>{children}</GestureHandler>
          </ConversionProvider>
        </PerspectiveListener>
      </PanProvider>
    </ZoomProvider>
  </DimensionsProvider>
);
